import moment from 'moment';
import { MobileChatStates } from '../reducers/chat';
import api from '../services/api';
import { transformMessageFromBackend } from '../services/dataTransformers';

export const CHANGE_MOBILE_STATE = 'CHANGE_MOBILE_STATE';
export const NEW_MESSAGE_SUCCESS = 'NEW_MESSAGE_SUCCESS';
export const NEW_MESSAGE_REQUEST = 'NEW_MESSAGE_REQUEST';
export const SET_ACTIVE_CHAT = 'SET_ACTIVE_CHAT';
export const OPEN_USERS_LIST = 'OPEN_USERS_LIST';

export function changeMobileState(payload) {
  return {
    type: CHANGE_MOBILE_STATE,
    payload
  }
}

export function openUsersList() {
  return {
    type: OPEN_USERS_LIST
  }
}

export function newMessageRequest(payload) {
  return async (dispatch) => {
    if (!payload.message || !payload.conversationId) return;

    dispatch({ type: NEW_MESSAGE_REQUEST });

    try {
      const messageData = {
        conversation_id: payload.conversationId,
        content: payload.message,
        sender_id: payload.senderId
      };

      const response = await api.sendMessage(messageData);

      // Transform backend response to frontend format
      const message = transformMessageFromBackend(response.data, payload.senderId);

      dispatch(newMessageSuccess({ dialogId: payload.conversationId, message }));
    } catch (error) {
      console.error('Failed to send message:', error);
      // You might want to dispatch an error action here
    }
  }
}

export function newMessageSuccess(payload) {
  return {
    type: NEW_MESSAGE_SUCCESS,
    payload
  }
}

export function setActiveChat(payload) {
  return (dispatch) => {
    dispatch({
      type: SET_ACTIVE_CHAT,
      payload
    })
    dispatch(changeMobileState(MobileChatStates.CHAT));
  }
}